export const POLLING_TIME = 1000 / 15;
